import CryptoJS from 'crypto-js';

// Encrypt data
export function encryptData(data) {
  if (data !== null) {
    const dataString = JSON.stringify(data);

    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken || accessToken.length < 32) {
      throw new Error("Invalid access token.");
    }

    const keyBase64 = accessToken.substring(0, 32); // Use 32 characters for key
    const key = CryptoJS.enc.Base64.parse(keyBase64);
    const iv = CryptoJS.lib.WordArray.random(128 / 8);

    const encrypted = CryptoJS.AES.encrypt(dataString, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const encryptedData = {
      iv: CryptoJS.enc.Base64.stringify(iv),
      value: encrypted.toString(), // Already in Base64
    };

    return btoa(JSON.stringify(encryptedData));
  } else {
    return null;
  }
}
